import Echo from "laravel-echo";
const token = JSON.parse(localStorage.getItem("@revalida.token") as any);
import Pusher from "pusher-js";

declare global {
  interface Window {
    Pusher: any;
  }
}

window.Pusher = Pusher;

const options =
  import.meta.env.VITE_APP_DEV_WEBSOCKET == "false"
    ? {
        broadcaster: "reverb",
        key: import.meta.env.VITE_APP_WEBSOCKET_KEY,
        cluster: import.meta.env.VITE_APP_WEBSOCKET_CLUSTER ?? "mt1",
        wsHost: import.meta.env.VITE_APP_WEBSOCKET_HOST,
        wsPort: import.meta.env.VITE_APP_WEBSOCKET_PORT ?? 80,
        wssPort: import.meta.env.VITE_APP_URL_WEBSOCKET_PORT ?? 443,
        //wsPath: "/pusher",
        //wsPath: import.meta.env.VITE_APP_WEBSOCKET_PATH ?? "/app",
        forceTLS: true, // <<<<<<<<<< aqui muda para true
        enabledTransports: ["ws", "wss"],
        disableStats: true,
        authEndpoint: import.meta.env.VITE_APP_AUTH_BROADCAST,
        auth: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      }
    : {
        broadcaster: "reverb",
        key: import.meta.env.VITE_APP_WEBSOCKET_KEY,
        cluster: import.meta.env.VITE_APP_WEBSOCKET_CLUSTER ?? "mt1",
        wsHost: import.meta.env.VITE_APP_WEBSOCKET_HOST,
        wsPort: import.meta.env.VITE_APP_WEBSOCKET_PORT ?? 80,
        wssPort: import.meta.env.VITE_APP_URL_WEBSOCKET_PORT ?? 443,
        // wsPath: import.meta.env.VITE_APP_WEBSOCKET_PATH ?? "/app",
        // wsPath: "/laravel-websockets",
        forceTLS: true, // <<<<<<<<<< aqui também muda para true
        enabledTransports: ["ws", "wss"], // habilita ws e wss
        disableStats: true,
        authEndpoint: import.meta.env.VITE_APP_AUTH_BROADCAST,
        auth: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      };

Pusher.logToConsole = true;
const laravelEcho = new Echo(options);

laravelEcho.connector.pusher.connection.bind("connected", function () {
  console.log(
    "%cEcho: Conectado com sucesso via WSS!",
    "color: green; font-weight: bold;"
  );
});

laravelEcho.connector.pusher.connection.bind("error", function (err) {
  console.error(
    "%cEcho: Erro de conexão WebSocket via WSS!",
    "color: red; font-weight: bold;",
    err
  );
  if (err.error && err.error.data) {
    console.error("Pusher Erro Code:", err.error.data.code);
    console.error("Pusher Erro Message:", err.error.data.message);
  }
});

laravelEcho.connector.pusher.connection.bind("state_change", function (states) {
  console.log(
    "%cEcho: Mudança de estado da conexão WSS:",
    "color: blue;",
    states
  );
});

laravelEcho.connector.pusher.connection.bind("disconnected", function () {
  console.log("%cEcho: Desconectado do WSS.", "color: orange;");
});

export { laravelEcho };
